"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AspectRatioBox = _interopRequireDefault(require("./AspectRatioBox"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _default = _AspectRatioBox.default;
exports.default = _default;